export default __webpack_public_path__ + "nav-side-bg.png?0b957334224102c36ef54e2dc73b63cf";